export const apiPath = '/v2/incidents';
const actionType = 'INCIDENTS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
